const TRANSITION = { duration: .4, ease: [.1, .7, .7, 1] };
const CONTENT_TRANSITION = { duration: .5, ease: [.1, .7, .7, 1] };

export const FRAME = {
  hidden: {},
  visible: { transition: { delayChildren: .3, staggerChildren: .1 } },
};

export const ANIM_TOP = {
  hidden: { opacity: 0, y: -20 },
  visible: { opacity: 1, y: 0, transition: TRANSITION },
};

export const ANIM_BOTTOM = {
  hidden: { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0, transition: TRANSITION },
};

export const ANIM_CONTENT = {
  initial: (direction) => (
    direction === 0 ? { opacity: 0, y: -12 } : { opacity: 0, x: direction * 40 }
  ),
  animate: { opacity: 1, x: 0, y: 0 },
  exit: (direction) => (
    direction === 0 ? { opacity: 0, y: 12 } : { opacity: 0, x: direction * -40 }
  ),
};

export const getContentTransition = (direction) => ({
  ...CONTENT_TRANSITION,
  delay: direction === 0 ? .21 : 0,
});
